var map = {
	"./berlinfuchs.vue": 102,
	"./digital-data-collection.vue": 111,
	"./droplet.vue": 114,
	"./maria-jose-moreno.vue": 117,
	"./robots-and-ai.vue": 120,
	"./zissel.vue": 123
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 101;


//////////////////
// WEBPACK FOOTER
// ./components/single \.(vue)$
// module id = 101
// module chunks = 0